export enum NewServiceErrorEnum {
    BLOCKED_SEC_PASS = '1-019',
    CHECKPIN_SERVICE_FAILURE = '0-010',
    CONFRONTA_WRONG_ANSWERS = '016',
    SECURE_PASSWORD_BLOCKED_OTHER_MEDIUM= '017',
    DEBIT_CARD_BLOCKED_OTHER_MEDIUM= '1-018',
    DEBIT_CARD_BLOCKED_BY_SECURITY_DAYS = '119',
    BLOCKING_BY_ASSESSOR_CERTIFICATE = '124',
    SINGLE_SESSION_BLOCKED = '1-022',
    BLOCKED_SECURE_KEY = '118',
    SECURE_KEY_WRONG = '1-013',
    CONNECTION_ERROR = '1-014'
}



// WEBPACK FOOTER //
// ./src/app/enums/new-service-error.enum.ts